import React, { Component } from 'react';
import { connect } from 'dva';
import { Button, Row, Col, Form, Input, Tooltip, message, DatePicker } from 'antd';
import moment from 'moment';
import { getAppCode } from '../../../../utils/utils';
import ListPage from '../../../../../../../components/ListPage';
import { getLabelStrData } from '../../../../utils/convertData';
import styles from './index.less';

const { ListTable } = ListPage;
const { RangePicker } = DatePicker;

const defaultDate = moment().format('YYYY-MM-DD');

@connect(({ push }) => ({
  ...push,
}))

class ArticleTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      columns: [],
    };
  }

  componentDidMount() {
    const { params } = this.props;
    this.setColumns();
    this.fetchNewsManagerList(params);
  }

  search = e => {
    e.preventDefault();
    const { form, dispatch, params, } = this.props;
    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const rangeValue = values['range-picker'];
        const tempParams = {
          ...params,
          title: values.title ? encodeURIComponent(values.title) : '',
          startDay: rangeValue && rangeValue[0] ? rangeValue[0].format('YYYY-MM-DD') : defaultDate,
          endDay: rangeValue && rangeValue[1] ? rangeValue[1].format('YYYY-MM-DD') : defaultDate,
          page: 1,
        };
        dispatch({
          type: 'push/saveState',
          payload: {
            params: tempParams,
          },
        });
        this.fetchNewsManagerList(tempParams);
      }
    });
  };

  reSet = () => {
    const { form, dispatch, params } = this.props;
    form.resetFields();
    const tempParams = {
      ...params,
      title: '',
      channelId: '',
      page: 1,
    };
    dispatch({
      type: 'push/saveState',
      payload: {
        params: tempParams,
      },
    });
    this.fetchNewsManagerList(tempParams);
  };

  fetchNewsManagerList = params => {
    const { dispatch, } = this.props;
    this.setLoading(true);
    dispatch({
      type: 'courseManage/fetchNewsManagerList',
      params: { ...params },
    })
      .then(res => {
        dispatch({
          type: 'push/saveState',
          payload: {
            dataSource: getLabelStrData(res),
            totalElements: res.totalElements,
          },
        });
        this.setLoading(false);
      })
      .catch(() => {
        this.setLoading(false);
      });
  };

  setLoading = flag => {
    const { dispatch } = this.props;
    dispatch({
      type: 'push/saveState',
      payload: {
        spinning: flag,
      },
    });
  };

  setColumns = () => {
    const { type } = this.props;
    let columns = [];
    if (type === 'batchPush') {
      columns = [
        {
          title: '主题',
          dataIndex: 'title',
          key: 'title',
          width: 280,
          fixed: 'left',
          render: text => {
            if (text.length <= 20) {
              return <span>{text}</span>;
            }
            return (
              <Tooltip placement="top" title={text}>
                <span>{text.substring(0, 20)}...</span>
              </Tooltip>
            );
          },
        },

        {
          title: '类型',
          dataIndex: 'newstype',
          key: 'newstype',
          width: 150,
          // eslint-disable-next-line consistent-return
          render: text => {
            if (Number(text) === 3) {
              return '独立课程';
            }
            if (Number(text) === 4) {
              return '章节课程';
            }
          },
        },
        {
          title: '子课程数',
          dataIndex: 'newsInfoList',
          key: 'newsInfoList',
          width: 150,
          render: text => {
            return <span>{text?.length || 0}</span>;
          },
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          key: 'createTime',
          render: text => {
            return <span>{moment(text).format('YYYY.MM.DD HH:mm')}</span>;
          },
        },
      ]
    }
    this.setState({ columns });
  };

  changePage = (page, pageSize) => {
    const { params, dispatch } = this.props;
    const tempParams = {
      ...params,
      page,
      pageSize,
    };
    dispatch({
      type: 'push/saveState',
      payload: {
        params: tempParams,
      },
    });
    this.fetchNewsManagerList(tempParams);
  };

  select = (id, record) => {
    const { dispatch, selectedRow = [] } = this.props;
    const tempArr = [];
    const selectedRowKeys = [];
    let flag = true;

    selectedRow.forEach(item => {
      if (item.id === record.id) {
        flag = false;
      }
      tempArr.push(item);
      selectedRowKeys.push(item.id);
    });
    if (flag) {
      if (selectedRow.length === 8) {
        message.warning('最多只能选8篇');
        return;
      }
      tempArr.push(record);
      selectedRowKeys.push(record.id);
    } else {
      tempArr.splice(selectedRowKeys.indexOf(id), 1);
      selectedRowKeys.splice(selectedRowKeys.indexOf(id), 1);
    }

    dispatch({
      type: 'push/saveState',
      payload: {
        selectedRow: tempArr,
        selectedRowKeys,
      },
    });
  };

  // 全选
  selectAll = (selected, selectedRows) => {
    const { dispatch, selectedRow } = this.props;
    const { selectedRowKeys } = this.props;
    const arr = [];
    const idArr = [];
    selectedRow.forEach(item => {
      arr.push(item);
    });
    selectedRowKeys.forEach(item => {
      idArr.push(item);
    });
    if (selected) {
      dispatch({
        type: 'push/saveState',
        payload: {
          selectedRowAll: selectedRows,
        },
      });
      selectedRows.forEach(item => {
        if (selectedRowKeys.indexOf(item.id) === -1) {
          arr.push(item);
          idArr.push(item.id);
        }
      });
      if (arr.length > 8) {
        message.warning('最多只能选8篇');
      } else {

        dispatch({
          type: 'push/saveState',
          payload: {
            selectedRow: arr,
            selectedRowKeys: idArr,
          },
        });
      }
    } else {
      const { selectedRowAll } = this.props;
      const newArr = [];
      const newIdArr = [];
      const allIdArr = [];
      const allArr = [];

      selectedRowAll.forEach(item => {
        allIdArr.push(item.id);
        allArr.push(item);
      });
      selectedRowKeys.forEach(item => {
        if (allIdArr.indexOf(item) === -1) {
          newIdArr.push(item);
        }
      });
      selectedRow.forEach(item => {
        if (allIdArr.indexOf(item.id) === -1) {
          newArr.push(item);
        }
      });

      dispatch({
        type: 'push/saveState',
        payload: {
          selectedRow: newArr,
          selectedRowKeys: newIdArr,
        },
      });
    }
  };

  render() {
    const { columns, } = this.state;
    const { form, dataSource, params, totalElements, selectedRowKeys = [] } = this.props;
    const { page } = params;
    const { getFieldDecorator } = form;
    const formItemLayout = {
      labelCol: { span: 10 },
      wrapperCol: { span: 14 },
    };
    const rowSelection = {

      onSelect: (record) => {
        this.select(record.id, record);
      },
      onSelectAll: (selected, selectedRows) => {
        //  selectedRows是当前全选选中的集合
        // selectedRow是之前已经选中的集合
        this.selectAll(selected, selectedRows);
      },
      selectedRowKeys,
    };

    const tableProps = {
      pageInfo: { totalElements, page },
      columns,
      list: dataSource,
      rowKey: 'id',
      rowSelection,
      onPageChange: this.changePage,
      onItemClick: this.select,
    };

    return (
      <div className={styles.root}>
        <Row className={styles['search-area']}>
          <Col span={8}>

            <Form.Item {...formItemLayout} label="主题">
              {getFieldDecorator('title', {
                rules: [
                  {
                    max: 50,
                    message: '请勿超过50个字!',
                  },
                ],
              })(<Input placeholder="请输入标题" onPressEnter={this.search} />)}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item {...formItemLayout} label="时间">
              {getFieldDecorator(`range-picker`, {
                initialValue: [
                  moment(moment().add(-6, 'M'), 'YYYY.MM.DD'),
                  moment(new Date(), 'YYYY.MM.DD'),
                ],
              })(<RangePicker format="YYYY.MM.DD" placeholder={['请选择', '请选择']} />)}
            </Form.Item>
          </Col>
          <Col offset={16} className="search-button">
            <Form.Item>
              <Button type="primary" onClick={this.search}>
                查询
              </Button>
              <Button onClick={this.reSet}>重置</Button>
            </Form.Item>
          </Col>
        </Row>
        <section className="table-area">
          <ListTable {...tableProps} />
        </section>
      </div>
    );
  }
}

const ArticleTableFrom = Form.create()(ArticleTable);
export default ArticleTableFrom;
